export default [
    {
        path: 'alergia',
        component: () => import(/* webpackChunkName: 'cadastro-alergia' */ '@/views/cadastro/alergia/Index'),
        redirect: 'alergia/index',
        children: [
            {
                name: 'cadastro-alergia-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-alergia' */ '@/views/cadastro/alergia/List'),
            },
            {
                name: 'cadastro-alergia-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'cadastro-alergia' */ '@/views/cadastro/alergia/Form'),
            },
            {
                name: 'cadastro-alergia-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(/* webpackChunkName: 'cadastro-alergia' */ '@/views/cadastro/alergia/Form'),
            },
        ]
    }
]